exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-project-component {\n  width: 100%;\n}\n.loader-lg {\n  margin: 0;\n}\n.file-name {\n  color: #242F94;\n}\n.delete-file-btn:hover {\n  cursor: pointer;\n}\n.link {\n  color: #EB5757;\n}", ""]);

// exports
